import { createAction, props } from '@ngrx/store';

export enum IbanRegionsActions {
  IbanRegionsRequested = '[IbanRegions] IbanRegions Requested',
  IbanRegionsLoaded = '[IbanRegions] IbanRegions Loaded',
  IbanRegionsError = '[IbanRegions] IbanRegions Error',
  AddIbanRegion = '[IbanRegions] Add IbanRegion',
  AddIbanRegionSuccess = '[IbanRegions] Add IbanRegion Success',
  AddIbanRegionError = '[IbanRegions] Add IbanRegion Error',
  UpdateIbanRegion = '[IbanRegions] Update IbanRegion',
  UpdateIbanRegionSuccess = '[IbanRegions] Update IbanRegion Success',
  UpdateIbanRegionError = '[IbanRegions] Update IbanRegion Error',
  DeleteIbanRegion = '[IbanRegions] Delete IbanRegion',
  DeleteIbanRegionSuccess = '[IbanRegions] Delete IbanRegion Success',
  DeleteIbanRegionError = '[IbanRegions] Delete IbanRegion Error'
}

export const IbanRegionsRequested = createAction(IbanRegionsActions.IbanRegionsRequested);

export const IbanRegionsLoaded = createAction(IbanRegionsActions.IbanRegionsLoaded,
    props<{ ibanRegions: [] }>());

export const IbanRegionsError = createAction(IbanRegionsActions.IbanRegionsError);

export const AddIbanRegion = createAction(
  IbanRegionsActions.AddIbanRegion,
  props<{ ibanRegion: any, userId: string }>()
);

export const AddIbanRegionSuccess = createAction(
  IbanRegionsActions.AddIbanRegionSuccess,
  props<{ ibanRegion: any }>()
);

export const AddIbanRegionError = createAction(IbanRegionsActions.AddIbanRegionError);

export const UpdateIbanRegion = createAction(
  IbanRegionsActions.UpdateIbanRegion,
  props<{ ibanRegion: any }>()
);

export const UpdateIbanRegionSuccess = createAction(
  IbanRegionsActions.UpdateIbanRegionSuccess,
  props<{ ibanRegion: any }>()
);

export const UpdateIbanRegionError = createAction(IbanRegionsActions.UpdateIbanRegionError);

export const DeleteIbanRegion = createAction(
  IbanRegionsActions.DeleteIbanRegion,
  props<{ ibanRegionId: any }>()
);

export const DeleteIbanRegionSuccess = createAction(
  IbanRegionsActions.DeleteIbanRegionSuccess,
  props<{ ibanRegionId: any }>()
);

export const DeleteIbanRegionError = createAction(IbanRegionsActions.DeleteIbanRegionError);